import React, { useState, useRef, useLayoutEffect } from 'react';
import { Editor } from 'draft-js';
import './Textarea.css';
import { styleMap } from './helpers';
import { useTooltip } from '../../hooks';
import { Label } from '../';

export const TextareaReadOnly = ({ value, maxLines = 10, name, label, title }) => {
  const [expanded, setExpanded] = useState(maxLines ? false : true);
  const [clipped, setClipped] = useState(false);
  const [maxHeightPx, setMaxHeightPx] = useState(null);

  const { showTooltip, hideTooltip } = useTooltip();

  const containerRef = useRef(null);

  // compute maxHeight in px using actual line-height
  useLayoutEffect(() => {
    const el = containerRef.current;
    if (!el) return;
    const cs = getComputedStyle(el);
    // parse numeric line-height; fallback to font-size * 1.3 if "normal"
    let lineHeight = cs.lineHeight;
    if (lineHeight === 'normal') {
      lineHeight = parseFloat(cs.fontSize || '16') * 1.3 + 'px';
    }
    const lh = parseFloat(lineHeight);
    const maxHeight = Math.round(lh * maxLines);
    if (maxHeight < el.offsetHeight) {
      setMaxHeightPx(maxHeight);
      setClipped(true);
    }
  }, [maxLines, value]);

  const toggle = () => {
    setExpanded(prev => !prev);
  };

  return (
    <div className={'CustomTextareaReadOnly' + (expanded ? ' expanded' : '')}>
      <div
        className={'text' + (expanded ? ' expanded' : '')}
        ref={containerRef}
        style={
          maxHeightPx && !expanded ? { maxHeight: `${maxHeightPx}px` } : { maxHeight: `initial` }
        }
      >
        <Label label={label} title={title} htmlFor={name} disabled={true} />
        <Editor
          editorState={value}
          customStyleMap={styleMap}
          //blockRenderMap={extendedBlockRenderMap}
          readOnly={true}
        />
      </div>

      {maxLines && !expanded && maxHeightPx && clipped && <div className="show-more-overlay"></div>}

      {maxLines && clipped && (
        <div
          className={'show-more-toggle-button' + (expanded ? ' expanded' : '')}
          aria-label={expanded ? 'Hide' : 'Show more'}
          onClick={toggle}
          onMouseEnter={() =>
            showTooltip({ title: expanded ? 'Hide description' : 'Show entire description' })
          }
          onMouseLeave={hideTooltip}
        >
          {expanded ? 'Hide' : 'Show More'}
          <span></span>
        </div>
      )}
    </div>
  );
};
